module.exports = __webpack_public_path__ + "img/newyan.87de14bc.png";